import { render, staticRenderFns } from "./ModalAplicarModeloCirurgia.vue?vue&type=template&id=dbc48352&scoped=true"
import script from "./ModalAplicarModeloCirurgia.vue?vue&type=script&lang=ts"
export * from "./ModalAplicarModeloCirurgia.vue?vue&type=script&lang=ts"
import style0 from "./ModalAplicarModeloCirurgia.vue?vue&type=style&index=0&id=dbc48352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc48352",
  null
  
)

export default component.exports